import request from '@/utils/request'

// 登录请求
export function reqLogin(data) {
  return request({
    url: '/api/staffLogin',
    method: 'post',
    data
  })
}

// 发送验证码
export function sendStaffCaptcha(data) {
  return request({
    url: '/api/sendStaffCaptcha',
    method: 'post',
    data
  })
}

// 设置密码请求
export function reqSavePassword(data) {
  return request({
    url: '/api/staff/savePassword',
    method: 'post',
    data
  })
}